// --------------------------------------------------------------------------
// navToggle.js
// --------------------------------------------------------------------------
// 
// --------------------------------------------------------------------------

EC.navToggle = function () {

    'use strict';

    let $trigger;
    let $nav;

    function init () {
        $trigger = $('.js-nav-toggle');
        $nav = $('#js-mobile-nav');
        $trigger.on('click', toggleNav);
    }

    function toggleNav () {
        $trigger.toggleClass('e-nav-toggle--is-open');
        $nav.toggleClass('l-mobile-nav--is-open');
    }

    return {
        init: init
    };

}();